import { render, staticRenderFns } from "./EmployeeImport.vue?vue&type=template&id=1f21e4b2&scoped=true&"
import script from "./EmployeeImport.vue?vue&type=script&lang=js&"
export * from "./EmployeeImport.vue?vue&type=script&lang=js&"
import style0 from "./EmployeeImport.vue?vue&type=style&index=0&id=1f21e4b2&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f21e4b2",
  null
  
)

export default component.exports